import { getText } from "shared/lib";
import {
  TreePropertyType,
  updateTreeProperty,
  type ReasonTreePropertyDescriptor,
  type TreeDescriptor,
} from "../lib";
import { useTreeDialogValidator } from "./lib";

import { Textarea } from "shared/components";
import { FieldLabel } from "./FieldLabel";
import { FieldValidationMessages } from "./FieldValidationMessages";

export interface ReasonFieldProps {
  label?: string;
  onChange: (treeDescriptor: TreeDescriptor) => void;
  placeholder?: string;
  treeDescriptor: TreeDescriptor;
}

export function ReasonField<T extends ReasonTreePropertyDescriptor>({
  label = getText("Reason"),
  onChange,
  placeholder = getText("Enter reason"),
  treeDescriptor,
}: ReasonFieldProps) {
  const { isValid, messages } = useTreeDialogValidator<T>({
    checker: (property) => !!property?.value,
    properties: treeDescriptor.properties,
    treePropertyType: TreePropertyType.reason,
  });

  const reason = treeDescriptor.properties.get(TreePropertyType.reason) as
    | T
    | undefined;

  const handleChange = (value: string) => {
    const newTreeDescriptor = updateTreeProperty<T>(
      treeDescriptor,
      TreePropertyType.reason,
      (draft) => {
        draft.value = value as T["value"];
      },
    );

    onChange?.(newTreeDescriptor);
  };

  return (
    <div className="flex flex-col gap-2">
      <FieldLabel isValid={isValid}>{label}</FieldLabel>

      <Textarea
        className="invalid-sibling-label:border-redDefault"
        onChange={(event) => {
          handleChange(event.target.value);
        }}
        placeholder={placeholder}
        value={reason?.value || ""}
      />

      <FieldValidationMessages messages={messages} />
    </div>
  );
}
